// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"index-module--subtitle--tYhYT","title":"index-module--title--3zgkX","description":"index-module--description--3qha-"};